import { queryOptions, useQuery } from "@tanstack/react-query";
import { Type } from "typebox";
import * as TypeCompiler from "typebox/compile";
import { ReadonlyObject } from "@/shared/schema/schema.ts";
import { httpChecked } from "@/shared/util/fetch.ts";
import { getCvPartner } from "@/shared/util/getCvPartner.ts";

const schema = ReadonlyObject({
  minimum_compatible_version: Type.Integer(),
});

const checker = TypeCompiler.Compile(schema);

const queries = {
  check: queryOptions({
    queryKey: ["minimum_compatible_version"] as const,
    queryFn: ({ signal }) =>
      httpChecked.get("/api/v2/minimum_compatible_version", checker, {
        signal,
        skipLoadingIndicator: true,
      }),
  }),
};

export function useClientOutdated() {
  const { data } = useQuery({
    ...queries.check,
    refetchInterval: 10 * 60_000,
    // without this the global 150ms default applies, and refetchOnWindowFocus
    // would check again on every tab focus rather than on the interval
    staleTime: 10 * 60_000,
    select: (data) =>
      getCvPartner().minimumCompatibleVersion < data.minimum_compatible_version,
    // a failed check is not worth retrying (the interval retries anyway) and
    // not worth reporting: during an outage every open client would otherwise
    // multiply its requests and emit an error per poll, amplifying the incident
    retry: false,
    meta: { skipErrorLogging: true },
  });

  return data === true;
}
